import { render, staticRenderFns } from "./BlogArticleEdit.vue?vue&type=template&id=3f3cc808"
import script from "./BlogArticleEdit.vue?vue&type=script&lang=ts"
export * from "./BlogArticleEdit.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports